import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="card border-danger my-3">
          <div className="card-body text-center py-4">
            <div className="fs-2 mb-2">⚠️</div>
            <h5 className="card-title text-danger">Something went wrong</h5>
            <p className="card-text text-secondary small">
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
            <button className="btn btn-outline-danger btn-sm" onClick={this.handleReset}>
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
